import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@icon/todo-review.svg'
import _imports_1 from '@icon/list-unordered-v2.svg'
import _imports_2 from '@icon/flag.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"var(--serviceAlert-02)"} }, "due soon", -1)
const _hoisted_2 = { class: "notification__todo-reminder-list" }
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_ReferencedText = _resolveComponent("ReferencedText")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NotificationTemplate = _resolveComponent("NotificationTemplate")!
  const _directive_ticket = _resolveDirective("ticket")!

  return (_openBlock(), _createBlock(_component_NotificationTemplate, {
    notification: _ctx.notification,
    showSubTitle: false
  }, {
    pic: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["label-pic", _ctx.isPmReviewReminder ? 'is-review' : 'is-blue'])
      }, [
        (_ctx.isPmReviewReminder)
          ? (_openBlock(), _createBlock(_component_icon, {
              key: 0,
              data: _imports_0,
              class: "label-pic__icon",
              fill: true,
              width: "var(--icon-24)",
              height: "var(--icon-24)"
            }))
          : (_openBlock(), _createBlock(_component_icon, {
              key: 1,
              data: _imports_1,
              class: "label-pic__icon",
              width: "var(--icon-24)",
              height: "var(--icon-24)",
              color: "#1565C0"
            }))
      ], 2)
    ]),
    title: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "large",
        color: "monochrome-06",
        darkColor: "monochrome-03",
        weight: "500"
      }, {
        default: _withCtx(() => [
          (_ctx.isPmReviewReminder)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" Just a reminder, you have Item awaiting PM Review ")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" Just a reminder, these ToDo(s) are "),
                _hoisted_1
              ], 64))
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notification?.content.dueSoonTodo, (todo, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "notification__todo"
          }, [
            (!todo.relatedUrl && !todo.url)
              ? _withDirectives((_openBlock(), _createBlock(_component_BaseSubHeading, {
                  key: 0,
                  size: "medium",
                  color: "monochrome-06",
                  darkColor: "monochrome-03",
                  weight: "400",
                  className: "notification__todo-item"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ReferencedText, {
                      resetStyle: true,
                      html: _ctx.notification.getTodoName(todo) || _ctx.$t('none')
                    }, null, 8, ["html"])
                  ]),
                  _: 2
                }, 1024)), [
                  [_directive_ticket, { wholeLink: true, todo: _ctx.notification.getProjectId(todo) }]
                ])
              : (_openBlock(), _createBlock(_component_BaseSubHeading, {
                  key: 1,
                  size: "medium",
                  color: "monochrome-06",
                  darkColor: "monochrome-03",
                  weight: "400",
                  className: "notification__todo-item"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      target: "_blank",
                      href: todo.url || todo.relatedUrl
                    }, [
                      _createVNode(_component_ReferencedText, {
                        resetStyle: true,
                        html: _ctx.notification.getTodoName(todo) || _ctx.$t('none')
                      }, null, 8, ["html"])
                    ], 8, _hoisted_3)
                  ]),
                  _: 2
                }, 1024)),
            (todo.urgent)
              ? (_openBlock(), _createBlock(_component_icon, {
                  key: 2,
                  data: _imports_2,
                  fill: true,
                  width: "14",
                  height: "14",
                  class: "notification__todo-icon",
                  color: "#D32F2F"
                }))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      (_ctx.notification?.content.hasMore)
        ? (_openBlock(), _createBlock(_component_BaseSubHeading, {
            key: 0,
            size: "medium",
            color: "monochrome-06",
            darkColor: "monochrome-03",
            weight: "500",
            className: "notification__todo-see-all"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" There are more! "),
              (_ctx.$route.params.accountId)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "notification__todo-see-all-link",
                    replace: "",
                    to: { query: { ..._ctx.$route.query, toDo: 'true' } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" See All ")
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["notification"]))
}